module.exports = __webpack_public_path__ + "static/media/logomonarque.5995b29f.png";